import React, { Component } from "react";
import api from '../api';
import MuiAlert from '@material-ui/lab/Alert';
import ViewIcon from '@material-ui/icons/Visibility';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Snackbar from '@material-ui/core/Snackbar';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}
  
class ShiftEmailPreview extends React.Component {
    constructor(props) {
      	super(props);
		this.state = {email_preview:'',sending:false, dialog:{open: false},snackbar:{open:false, severity: ''}}
  	}

    async componentDidMount() {
    	//await this.getShiftEmailPreview()
    }

    getShiftEmailPreview(){
	    var formData = new FormData();
	    formData.set("id", this.props.id);
	    formData.set("address", this.props.address);
	    formData.set("shift_date", this.props.shift_date);
	    formData.set("shift_additional_notes", this.props.shift_additional_notes);

		const token = localStorage.getItem('userToken')
		return axios.post(api.work_order().preview_email_shift(),
	       formData,
	       {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
	       )
	      .then(res => {
	      		this.setState({email_preview: res.data})
	      })
	      .catch(err =>{console.log(err)
	      })

    }

  	handleDialog = () =>{
        var dialog = this.state.dialog
        dialog.open = !dialog.open
  		this.setState({dialog})
  	}

    handleReSend = () => {
        this.setState({sending: true})
	    var formData = new FormData();
	    formData.set("id", this.props.id);
		const token = localStorage.getItem('userToken')
		return axios.post(api.work_order().resend_shift_email(),
	       formData,
	       {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
	       )
	      .then(res => {
            var snackbar = this.state.snackbar
            snackbar.open = true
            snackbar.severity = 'success'
            snackbar.success_message = 'Mail con éxito'
            this.setState({snackbar:snackbar, sending: false})


          })
	      .catch(err =>{console.log(err)
            var snackbar = this.state.snackbar
            snackbar.open = true
            snackbar.severity = 'warning'
            snackbar.success_message = 'Falló el envio del mail.'
            this.setState({snackbar:snackbar})
	      })        
    }

    handleSnackbar = (e) => {
    	e.preventDefault()
    	var snackbar = this.state.snackbar
    	snackbar.open = !snackbar.open
    	this.setState({snackbar: snackbar})
    }


	render() {
		var dialog = this.state.dialog

		return (
			<React.Fragment>
                <ViewIcon fontSize="small" onClick={(e)=> {this.getShiftEmailPreview(); this.handleDialog()}} />                
                <Dialog open={dialog.open} fullWidth aria-labelledby="responsive-dialog-title" onClose={(e)=> {this.handleDialog()}} maxWidth="xl">
                    <DialogTitle id="responsive-dialog-title">{"Mail turno"}</DialogTitle>
                    <DialogContent>
                        <Snackbar open={this.state.snackbar.open} onClose={this.handleSnackbar}>
							<Alert onClose={this.handleSnackbar} severity={this.state.snackbar.severity}>
							  {this.state.snackbar.success_message}
							</Alert>
						</Snackbar>

                        <DialogContentText>
                            {(this.state.email_preview)
                            ?
                                <div dangerouslySetInnerHTML={{ __html: this.state.email_preview }}></div>
                            :
                                ''
                            }
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions disableSpacing="false">
                        {(this.props.show_resend && !this.state.sending)
                        ?
                            <Button onClick={(e)=>{this.handleReSend()}} variant="contained" color="primary" >
                                Reenviar
                            </Button>
                        :
                            ''
                        }
                        <Button onClick={(e)=>{this.this.handleDialog()}} variant="contained" color="secondary" className="ml-2" >
                            Cerrar
                        </Button>

                    </DialogActions>
                </Dialog>
            </React.Fragment>
		)
	}

}

export default ShiftEmailPreview;

